document.addEventListener('DOMContentLoaded', function() {
  const viewer = document.getElementById('policyViewer');
  
  // Questa funzione "libera" il pop-up e lo centra perfettamente sul telefono
  if (viewer && viewer.parentNode !== document.body) {
    document.body.appendChild(viewer);
  }

  const cards = document.querySelectorAll('.info-card');
  const viewerTitle = document.getElementById('viewerTitle');
  const viewerContent = document.getElementById('viewerContent');
  const closeBtn = document.querySelector('.policy-viewer-close');
  const overlay = document.querySelector('.policy-viewer-overlay');

  cards.forEach(card => {
    card.addEventListener('click', function() {
      const title = this.querySelector('h3').innerText;
      const content = this.querySelector('.policy-hidden-content').innerHTML;

      viewerTitle.innerText = title;
      viewerContent.innerHTML = content;

      viewer.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });
  });

  const closeViewer = () => {
    viewer.classList.remove('is-active');
    document.body.style.overflow = '';
  };

  if (closeBtn) closeBtn.addEventListener('click', closeViewer);
  if (overlay) overlay.addEventListener('click', closeViewer);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeViewer();
  });
});